import { ReactComponent as AvatarSmall } from "./avatar-small.svg";

const AvatarSmallIcon: React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string | undefined;
  }
> = (props) => <AvatarSmall {...props} />;

export default AvatarSmallIcon;
